import React, { Component } from 'react'

class KlarnaCheckout extends Component{
  renderSnippet = (htmlSnippet) => {
     var checkoutContainer = document.getElementById('my-checkout-container')
     checkoutContainer.innerHTML = htmlSnippet
     var scriptsTags = checkoutContainer.getElementsByTagName('script')
     for (var i = 0; i < scriptsTags.length; i++) {
         var parentNode = scriptsTags[i].parentNode
         var newScriptTag = document.createElement('script')
         newScriptTag.type = 'text/javascript'
         newScriptTag.text = scriptsTags[i].text
         parentNode.removeChild(scriptsTags[i])
         parentNode.appendChild(newScriptTag)
     }
  }

  componentDidMount() {
    let headers = {"Content-Type": "application/json"};
    const token = this.props.token;
    console.log("Old token " + this.props.token)
    //console.log("New token " + props.token)
    headers["Authorization"] = `Token ${token}`;
    fetch("/api/landing/klarna/checkout", {headers, method: "GET"})
      .then(res => {
        if (res.status === 200) {
          res.json().then(JsonResponse => {
            return this.renderSnippet(JsonResponse.htmlSnippet)
          })
        } else {
          throw res.status
        }
     })
  }

  render() {
    return(
      <div className="Landing-KlarnaCheckout">
        <div className="Checkout-top">
          <h2>Skapa abonnemang</h2>
          <p className="Cart-warning">
            Du behöver inte betala allt med en gång,
            betalning sker endast de månaderna du valt leverans.
          </p>
          <p className="Cart-warning">
            Vi gör endast ett testköp på 1kr för att bekräfta betalningsuppgifterna.
          </p>
        </div>
        <div id="my-checkout-container">
          <div id="loading"></div>
        </div>
      </div>
    )
  }
}

export default KlarnaCheckout



// WEBPACK FOOTER //
// ./src/containers/landing/KlarnaCheckout.jsx